import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { provideGoogleTagManager } from 'angular-google-tag-manager';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(),
    {provide: LOCALE_ID, useValue: 'de-DE'},
    provideGoogleTagManager({
      id: 'GTM-KDMZ7LQ5',
      gtm_csp_none: 'CSP-NONCE',
      gtm_mode: 'noisy',
    }),
  ],
};
